export default __webpack_public_path__ + "static/media/5_2.e8c56846.jpg";